module.exports = __webpack_public_path__ + "img/HHplakat2022.529ceae1.jpg";